import { useEffect, useState } from 'react';
import { api, type Stats } from '../api';

export default function Dashboard() {
  const [stats, setStats] = useState<Stats | null>(null);
  useEffect(() => { void api.stats().then(setStats); }, []);

  const cards = stats ? [
    { label: '账户总数', value: stats.accounts, sub: stats.enabledAccounts + ' 个启用', icon: '👥' },
    { label: '今日请求', value: stats.requestsToday, sub: '累计 ' + stats.requestsTotal, icon: '📨' },
    { label: '今日 Token', value: stats.tokensToday.toLocaleString(), sub: '累计 ' + stats.tokensTotal.toLocaleString(), icon: '🎯' },
  ] : [];

  return (
    <div className="p-6">
      <h2 className="mb-4 text-lg font-semibold text-[#272b33]">📊 仪表盘</h2>
      <div className="mb-6 grid grid-cols-1 gap-3 md:grid-cols-3">
        {cards.map((c) => (
          <div key={c.label} className="rounded-lg border border-[#edeff2] bg-white p-4">
            <div className="text-xs text-[#898b8f]">{c.icon} {c.label}</div>
            <div className="mt-1 text-2xl font-bold text-[#272b33]">{c.value}</div>
            <div className="text-[11px] text-[#898b8f]">{c.sub}</div>
          </div>
        ))}
      </div>
      <div className="rounded-lg border border-[#edeff2] bg-white p-4">
        <h3 className="mb-3 text-sm font-semibold text-[#272b33]">消耗 Top 账户</h3>
        {!stats || stats.topAccounts.length === 0 ? (
          <div className="text-sm text-[#bcbdc0]">暂无使用数据</div>
        ) : (
          <table className="w-full text-sm">
            <thead><tr className="text-left text-xs text-[#898b8f]">
              <th className="pb-2">账户</th><th className="pb-2">请求数</th><th className="pb-2">Token 数</th>
            </tr></thead>
            <tbody>
              {stats.topAccounts.map((t) => (
                <tr key={t.accountName} className="border-t border-[#edeff2]">
                  <td className="py-2 text-[#272b33]">{t.accountName}</td>
                  <td className="py-2 text-[#565a60]">{t.requests}</td>
                  <td className="py-2 text-[#565a60]">{t.tokens.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <div className="mt-4 rounded-lg border border-[#c2dcff] bg-[#f0f6ff] p-4 text-xs leading-relaxed text-[#565a60]">
        <div className="mb-1 font-medium text-[#1966ff]">📡 客户端接入方式（OpenAI 兼容）</div>
        <div className="selectable">接口地址：<code className="text-[#1966ff]">https://xlb.tangdou2027.top/api/v1</code></div>
        <div className="selectable">API Key：账户管理中给每个用户发放的 token（形如 <code className="text-[#1966ff]">xlb_xxx</code>）</div>
        <div>客户端（如 AgentDesk 桌面版）在设置里填入 baseUrl 与 token 即可统一走本后台调用模型。</div>
      </div>
    </div>
  );
}